export default __webpack_public_path__ + "static/media/gallery_13.dbf8dd2e.jpg";